module.exports = __webpack_public_path__ + "static/media/banner.308fac4d.png";